import "core-js/modules/es6.regexp.replace";
import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 无品牌二维码弹框组件
 * <component-nobrand-qrcode v-if="isOpenShop&&shareLink"></component-nobrand-qrcode>
 */
import { updateUrlParam, toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
export default {
  name: 'nobrandQrcode',
  data: function data() {
    return {
      loadNobrandQrcode: false,
      //渲染无品牌二维码弹框
      showNobrandQrcode: false,
      //显示无品牌二维码弹框
      showOutAnimation: false,
      //展示关闭弹框动画

      status: 0 //二维码生成状态   0.未生成  1.生成中  2.已生成
    };
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == 'object' || (window.componentCenter = {});
    window.componentCenter.nobrandQrcode = this;
    console.log('ycf组件初始化：nobrandQrcode');
  },
  props: {
    type: {
      default: 1
    }
  },
  methods: {
    //关闭动画
    hideBox: function hideBox() {
      var _this = this;
      this.showOutAnimation = true;
      var timer = setTimeout(function () {
        clearTimeout(timer);
        _this.showOutAnimation = false;
        _this.showNobrandQrcode = false;
      }, 200);
    },
    //显示二维码
    showQrcode: function showQrcode(shareLink) {
      if (this.status == 2) {
        this.showNobrandQrcode = true;
        return;
      }
      if (typeof shareLink != 'string') return false;
      if (this.status == 1) return;
      this.status = 1;
      var that = this,
        link = shareLink;
      if (this.type == 1) {
        link = updateUrlParam(link, 'channel', 'noBrand');
      } else {
        link = updateUrlParam(link, 'scenicFrom', 'noBrand');
      }
      link = updateUrlParam(link, 'isShop', '1'); //带上店铺模式的标识

      var clearParamList = ['enterMode', 'source', 'tagId', 'tag_id', 'tagName', 'tag_name', 'tag2Id', 'tag2_id', 'tag2Name', 'tag2_name', 'itemId']; //需要清除的参数
      for (var _i = 0, _clearParamList = clearParamList; _i < _clearParamList.length; _i++) {
        var param = _clearParamList[_i];
        link = updateUrlParam(link, param, '');
      }
      while (/&$/.test(link)) {
        link = link.replace(/&$/, '');
      }
      while (/&&/.test(link)) {
        link = link.replace(/&&/g, '&');
      }
      databus({
        url: '/apiv2/marketing/getGoodsQrcode',
        type: 'get',
        data: {
          url: link
        },
        success: function success(res) {
          if (res.code == 1000 && res.bcode == 100) {
            that.loadNobrandQrcode = true;
            var img = new Image();
            img.onload = function () {
              that.status = 2;
              $('.component-nobrand-qrcode .QR-code').append(img);
              hideLoading();
              that.showNobrandQrcode = true;
            };
            img.onerror = function () {
              toast('网络有误，请刷新页面重试');
              that.status = 0;
              hideLoading();
            };
            img.src = res.content && res.content.qrcode || '';
          } else {
            toast(res.message || '无品牌二维码生成失败，请重试');
            that.status = 0;
            hideLoading();
          }
        },
        beforeSend: function beforeSend() {
          showLoading({
            cover: true,
            opacity: 0
          });
        },
        error: function error() {
          toast('网络有误，请重试');
          that.status = 0;
          hideLoading();
        }
      });
    }
  }
};